import React from "react";

import FoundryPageShell from "../components/foundry/FoundryPageShell";

import FlowBuilderSidebar from "../features/flow-builder/components/FlowBuilderSidebar";
import FlowBuilderMain from "../features/flow-builder/components/FlowBuilderMain";
import FlowBuilderInspector from "../features/flow-builder/components/FlowBuilderInspector";

import MapperModal from "../features/flow-builder/components/MapperModal";
import OutputPreviewModal from "../features/flow-builder/components/OutputPreviewModal";
import PayloadInputModal from "../features/flow-builder/components/PayloadInputModal";

import { useFlowBuilder } from "../features/flow-builder/hooks/useFlowBuilder";

import {
  outputSchemas,
  outputTypes,
} from "../features/flow-builder/flowBuilderConstants";

export default function FlowBuilderPage() {
  const [payloadInputOpen, setPayloadInputOpen] = React.useState(false);

  const {
    customersLoading,
    customersError,
    selectedCustomer,
    environment,
    setEnvironment,
    customerSearch,
    setCustomerSearch,
    customerPickerOpen,
    setCustomerPickerOpen,
    filteredCustomers,
    selectCustomer,
    flowSteps,
    selectedStep,
    selectedStepId,
    setSelectedStepId,
    addBlock,
    removeSelectedStep,
    triggerType,
    setTriggerType,
    payloadIsValid,
    payloadVariables,
    payloadArrays,
    selectedOutputFieldRows,
    targetPayloadType,
    outputType,
    outputSchema,
    payload,
    setPayload,
    inputFormat,
    setInputFormat,
    mapperModalOpen,
    setMapperModalOpen,
    outputPreviewOpen,
    setOutputPreviewOpen,
    payloadMappingEnabled,
    setPayloadMappingEnabled,
    selectedTargetPayload,
    suggestedPayloadMappings,
    setManualMappings,
    setMappingTransformations,
    setMappingConstants,
    setTargetPayloadType,
    bookingPayloadPreview,
    outputPreview,
    testCreateBooking,
    testBookingState,
    missingRequiredMappings,
    formatPayload,
  } = useFlowBuilder();

  return (
    <div className="flow-builder-page">
      <FoundryPageShell
        fullHeight
        flush
        sidebarWidth="w-[360px]"
        inspectorWidth="w-[420px]"
        sidebar={
          <FlowBuilderSidebar
            customersLoading={customersLoading}
            customersError={customersError}
            selectedCustomer={selectedCustomer}
            environment={environment}
            setEnvironment={setEnvironment}
            customerSearch={customerSearch}
            setCustomerSearch={setCustomerSearch}
            customerPickerOpen={customerPickerOpen}
            setCustomerPickerOpen={setCustomerPickerOpen}
            filteredCustomers={filteredCustomers}
            selectCustomer={selectCustomer}
            payloadIsValid={payloadIsValid}
            payloadVariables={payloadVariables}
            addBlock={addBlock}
            openPayloadEditor={() => setPayloadInputOpen(true)}
          />
        }
        main={
          <FlowBuilderMain
            flowSteps={flowSteps}
            selectedStepId={selectedStepId}
            setSelectedStepId={setSelectedStepId}
            addBlock={addBlock}
            openMapper={() => setMapperModalOpen(true)}
            openPayloadEditor={() => setPayloadInputOpen(true)}
            payloadIsValid={payloadIsValid}
            payloadVariableCount={payloadVariables.length}
            missingRequiredCount={missingRequiredMappings.length}
          />
        }
        inspector={
          <FlowBuilderInspector
            selectedStep={selectedStep}
            triggerType={triggerType}
            setTriggerType={setTriggerType}
            removeSelectedStep={removeSelectedStep}
            openPayloadEditor={() => setPayloadInputOpen(true)}
            customersLoading={customersLoading}
            customersError={customersError}
            selectedCustomer={selectedCustomer}
            environment={environment}
            setEnvironment={setEnvironment}
            customerSearch={customerSearch}
            setCustomerSearch={setCustomerSearch}
            customerPickerOpen={customerPickerOpen}
            setCustomerPickerOpen={setCustomerPickerOpen}
            filteredCustomers={filteredCustomers}
            selectCustomer={selectCustomer}
            payloadVariables={payloadVariables}
            payloadArrays={payloadArrays}
            payloadMappingEnabled={payloadMappingEnabled}
            setPayloadMappingEnabled={setPayloadMappingEnabled}
            selectedTargetPayload={selectedTargetPayload}
            missingRequiredCount={missingRequiredMappings.length}
            openMapper={() => setMapperModalOpen(true)}
            bookingPayloadPreview={bookingPayloadPreview}
            payloadIsValid={payloadIsValid}
            testCreateBooking={testCreateBooking}
            testBookingState={testBookingState}
            openOutputPreview={() => setOutputPreviewOpen(true)}
          />
        }
      />

      <PayloadInputModal
        open={payloadInputOpen}
        onClose={() => setPayloadInputOpen(false)}
        payload={payload}
        setPayload={setPayload}
        formatPayload={formatPayload}
        payloadIsValid={payloadIsValid}
        payloadVariablesCount={payloadVariables.length}
        payloadArraysCount={payloadArrays.length}
      />

      <MapperModal
        open={mapperModalOpen}
        onClose={() => setMapperModalOpen(false)}
        payload={payload}
        setPayload={setPayload}
        formatPayload={formatPayload}
        payloadIsValid={payloadIsValid}
        inputFormat={inputFormat}
        setInputFormat={setInputFormat}
        targetPayloadType={targetPayloadType}
        setTargetPayloadType={setTargetPayloadType}
        selectedTargetPayload={selectedTargetPayload}
        payloadVariables={payloadVariables}
        suggestedPayloadMappings={suggestedPayloadMappings}
        setManualMappings={setManualMappings}
        setMappingTransformations={setMappingTransformations}
        setMappingConstants={setMappingConstants}
        bookingPayloadPreview={bookingPayloadPreview}
        missingRequiredMappings={missingRequiredMappings}
      />

      <OutputPreviewModal
        open={outputPreviewOpen}
        onClose={() => setOutputPreviewOpen(false)}
        outputType={outputType}
        outputSchema={outputSchema}
        outputTypes={outputTypes}
        outputSchemas={outputSchemas}
        selectedOutputFieldRows={selectedOutputFieldRows}
        outputPreview={outputPreview}
      />
    </div>
  );
}
